"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _Button = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _TextLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/TextLink"));
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _InputField = _interopRequireDefault(require("@kiwicom/orbit-components/lib/InputField"));
var _reactIntl = require("react-intl");
var _context = require("../../../../services/log/context");
var _errors = _interopRequireDefault(require("../../../../consts/errors"));
var validators = _interopRequireWildcard(require("../../../../services/input/validators"));
var _apiV = require("../../../../services/auth/apiV2");
var _errors2 = require("../../../../services/auth/errors");
var _context2 = require("../../../../services/brand/context");
var _events = require("../../consts/events");
var _events2 = require("../../../../consts/events");
var _usePublishLoginStarted = _interopRequireDefault(require("../../consts/events/business/usePublishLoginStarted"));
var _jsxRuntime = require("react/jsx-runtime");
var _FormattedMessage;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const EmailLogin = _ref => {
  let {
    email,
    emailSuggestion,
    onOtpTransactionIdChange,
    screen,
    onEmailChange,
    onEmailCorrection,
    onChangeScreen
  } = _ref;
  const [error, setError] = (0, _react.useState)(null);
  const [validateEmail, setValidateEmail] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [isFocused, setIsFocused] = (0, _react.useState)(false);
  const {
    log
  } = (0, _context.useLog)();
  const intl = (0, _reactIntl.useIntl)();
  const brand = (0, _context2.useBrand)();
  const publishLoginStarted = (0, _usePublishLoginStarted.default)();
  const formRef = React.useRef(null);
  React.useEffect(() => {
    if (validateEmail) {
      const validationError = email ? validators.email(email) : _errors.default.requiredField;
      setError(validationError ? {
        message: validationError
      } : null);
    }
  }, [validateEmail, email]);
  React.useEffect(() => {
    setError(null);
  }, [screen]);
  const validateEmailInput = () => {
    const validationError = email ? validators.email(email) : _errors.default.requiredField;
    setValidateEmail(true);
    return Boolean(validationError);
  };
  const handleOtpRequestError = (errorMessage, retryAfter) => {
    switch (true) {
      case errorMessage.includes("INVALID_LOGIN"):
        log(_events.SIGN_IN_INVALID_LOGIN, {});
        setError({
          message: _errors.default.general
        });
        break;
      case errorMessage.includes("TOO_MANY_OTP_LOGIN_ATTEMPTS"):
        log(_events.SIGN_IN_BLOCKED_TEMPORARILY, {});
        const retrySeconds = retryAfter ? parseInt(retryAfter, 10) : 60;
        setError({
          message: _errors.default.rateLimited,
          retryAfter: retrySeconds
        });
        break;
      case errorMessage.includes("EMAIL_NOT_DELIVERABLE"):
        log(_events.LOGIN_STEP_FAILED, {
          operation: "onSignIn",
          error: errorMessage
        });
        setError({
          message: _errors.default.incorrectEmail
        });
        break;
      case errorMessage.includes("UNAUTHORIZED"):
      case errorMessage.includes("UNKNOWN"):
        log(_events.LOGIN_STEP_FAILED, {
          operation: "onSignIn",
          error: errorMessage
        });
        setError({
          message: _errors.default.general
        });
        break;
      default:
        setError({
          message: _errors.default.general
        });
        break;
    }
  };
  const handleEmailBlur = () => {
    setIsFocused(false);
    if (email === "") {
      return setError(null);
    }
    return setValidateEmail(true);
  };
  const handleEmailFocus = () => {
    setIsFocused(true);
    if (error !== null && error !== void 0 && error.retryAfter) {
      setError(null);
    }
  };
  const handleSignUp = () => {
    setLoading(true);

    // TEMP: Move logger back to handleSignIn once it's reintroduced
    if (screen === "newIntroSignIn") {
      publishLoginStarted("email_otp");
    }
    (0, _apiV.userRegister)({
      email,
      brand: brand === null || brand === void 0 ? void 0 : brand.id
    }).then(() => (0, _apiV.userOTPRequest)({
      email,
      brand: brand === null || brand === void 0 ? void 0 : brand.id
    })).then(res => {
      onOtpTransactionIdChange(res.transaction_id);
      setLoading(false);
      if (screen === "newIntroSignIn") {
        onChangeScreen("oneTimePasswordSignIn");
      } else {
        onChangeScreen("oneTimePasswordSignUp");
      }
    }).catch(error => {
      if (error instanceof _errors2.NetworkAbortError) {
        log(_events2.LOGIN_ABANDONED_REQUEST, {
          error: error.message
        });
      } else {
        var _error$headers;
        const retryAfter = (_error$headers = error.headers) === null || _error$headers === void 0 ? void 0 : _error$headers.get("Retry-After");
        handleOtpRequestError(error.message, retryAfter);
      }
      setLoading(false);
    });
  };
  const onContinue = e => {
    e.preventDefault();
    if (error) {
      setLoading(false);
      return;
    }
    setLoading(true);
    if (validateEmailInput()) {
      if (email === "") {
        setError({
          message: _errors.default.requiredField
        });
        setLoading(false);
        return;
      }
      setLoading(false);
      return;
    }
    // TEMP: Alway call /register endpoint till we improve UI
    handleSignUp();
  };
  const handleKeyDown = e => {
    if (e.key === "Enter") {
      e.preventDefault();
      onContinue(e);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
    ref: formRef,
    onSubmit: onContinue,
    name: "loginIntro",
    "data-test": "MagicLogin-EmailLogin",
    className: "pb-600",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputField.default, {
      autoFocus: true,
      inputMode: "email",
      autoComplete: "username",
      placeholder: intl.formatMessage({
        id: "account.login_modal.email_input_placeholder"
      }),
      value: email,
      error: error && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          ...error.message,
          values: {
            valueInSeconds: error.retryAfter
          }
        })
      }),
      onChange: onEmailChange,
      onBlur: handleEmailBlur,
      onFocus: handleEmailFocus,
      onKeyDown: handleKeyDown,
      name: "email",
      dataTest: "MagicLogin-Email",
      spaceAfter: "small",
      ariaLabel: intl.formatMessage({
        id: "account.login_modal.email_input_placeholder"
      })
    }), error && !isFocused && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      type: "critical",
      size: "small",
      spaceAfter: "medium",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        ...error.message,
        values: {
          valueInSeconds: error.retryAfter
        }
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      type: "secondary",
      size: "small",
      spaceAfter: "medium",
      children: emailSuggestion && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "common.did_you_mean",
        values: {
          x: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextLink.default, {
            asComponent: "button",
            dataTest: "MagicLogin-EmailCorrector",
            onClick: () => {
              onEmailCorrection();
            },
            children: emailSuggestion
          })
        }
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      fullWidth: true,
      submit: true,
      disabled: loading || error !== null,
      loading: loading,
      title: loading ? intl.formatMessage({
        id: "common.loading"
      }) : undefined,
      dataTest: "MagicLogin-Continue",
      type: "primarySubtle",
      children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.continue"
      }))
    })]
  });
};
var _default = exports.default = EmailLogin;